import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { initialiserApparence } from './theme/apparence-console';
import { initialiserFiligrane } from './theme/filigrane-console';
import './theme.css';

// AVANT le premier rendu, délibérément : la préférence d'apparence est posée
// sur `<html>` au chargement du module. Repoussée dans un effet React, elle
// laisserait la console peindre un écran clair pendant un cadre avant de
// basculer — le « flash blanc » qu'un tuteur travaillant le soir remarque.
initialiserApparence();
/* Avant le premier rendu, comme l'apparence : sinon la texture apparaîtrait
   le temps d'un cadre chez qui l'a désactivée. */
initialiserFiligrane();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Élément #root introuvable dans index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
